import {
  takeLatest, put, call, all,
} from 'redux-saga/effects';
import * as actions from '@actions';
import AuthorizationService from '@rootCommon/services/authorization-service';
import { Credentials } from '@rootTypes/auth';
import Profile from '@rootTypes/profile';

import { AxiosError } from 'axios';
import { SagaGenerator } from './index';

// sign in
function* userSignInAdminPanelAsync(action: { payload: Credentials }) {
  try {
    const authUser: Profile = yield call(AuthorizationService.adminAuthorization, action.payload);

    yield put(actions.signInAdminPanel.success(authUser));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.signInAdminPanel.failure(error));
  }
}

function* watchUserSignInAdminPanelLogin() {
  yield takeLatest(actions.signInAdminPanel.request, userSignInAdminPanelAsync);
}

// all
function* watchUserSignIn(): SagaGenerator {
  yield all([watchUserSignInAdminPanelLogin()]);
}

export default watchUserSignIn;
